<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M544 320C544 196.3 443.7 96 320 96C196.3 96 96 196.3 96 320C96 443.7 196.3 544 320 544C443.7 544 544 443.7 544 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM192 320C192 333.3 202.7 344 216 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L216 296C202.7 296 192 306.7 192 320zM160 320C160 289.1 185.1 264 216 264L424 264C454.9 264 480 289.1 480 320C480 350.9 454.9 376 424 376L216 376C185.1 376 160 350.9 160 320z"
      fill="currentColor"
    />
  </svg>
</template>